import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

import "../../styles/auth.css";
import "../../styles/notes.css";
import "../../styles/search.css";
import "../../styles/main.css";
import "../../styles/index.css";

import { categories } from "../../helpers/mock-data";
import { BmsHeader } from "../../components/main-components/app.header";
import { AppFooter } from "../../components/main-components/footer";
import { Loader } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { updatePublication } from "../../services/documents/documents.context";
import { AppAlert } from "../../components/utilities/alert";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";

export const UpdatePublication = () => {

    const { isLoading, token } = useAuth ();

    const { publication } = useLocation().state;

    const  id  = publication._id;

    const [bookData, setBookData] = useState({
        title: publication.title,
        authors: publication.authors,
        publishedYear: publication.publishedYear,
    });
    const [loading, setLoading] = useState(false);
    const [valError, setValError] = useState({
        caption: null,
        message: null
    });
    const [onErr, setOnErr] = useState(null);

    const handleUpload = async (id,token , data) => {
        setLoading(true);
        const res = await updatePublication(id,token, data);
            if (!res?.error){
                setOnErr(true);
                setValError({
                    caption: "Success",
                    message: res?.message
                })
            }else{
                setOnErr(true);
                setValError({
                    caption: "Error",
                    message: res?.error
                })
            }
            setLoading(false);
    }

    const { title, authors } = bookData;

    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = () => {
        return isNull (title) || isNull(authors);
    }

    const fileButton = useRef();

    return (
        <div>
            <BmsHeader />
            <div className='notes-bg'></div>
            <div className='skew-box'>
                helo
            </div>
            <div className='straight-box'>
                helo
            </div>
            <div className="notes-page">
            {(loading || isLoading) && <Loader />}
            {onErr && 
                <AppAlert 
                    caption={valError.caption}
                    message={valError.message}
                    close={() => setOnErr(false)}
                    accept={"Ok"}
                    acceptAction={() => setOnErr(false)}
                />
            }
                <div className="main-page">

                    <div className="search-caption">Update publication</div>
                        <div className="form-container">
                            <div className="input-container">
                                <span className="input-cap">
                                    Title
                                    <span className="req-asterix">*</span>
                                </span>
                                
                                <input 
                                    type="text" 
                                    placeholder="Title of lecture notes" 
                                    className="input"
                                    value={publication.title}
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, title: e.target.value})
                                    )}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">
                                    Author(s)
                                    <span className="req-asterix">*</span>
                                </span>
                                <input 
                                    type="text" 
                                    className="input"
                                    placeholder="First names of authors" 
                                    value={publication.authors}
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, authors: e.target.value})
                                    )}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Publisher</span>
                                <input 
                                    type="text" 
                                    className="input"
                                    value={publication.publisher}
                                    placeholder="Publisher" 
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, publisher: e.target.value})
                                    )}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Published year</span>
                                <input 
                                    type="number" 
                                    className="input"
                                    placeholder="Year published" 
                                    value={publication.publishedYear}
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, publishedYear: e.target.value})
                                    )}
                                    required
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">
                                    Category
                                    <span className="req-asterix">*</span>
                                </span>
                                <select 
                                    type="text" 
                                    name="category" 
                                    id="category" 
                                    className={classNames("input", "category")} 
                                    required
                                    onChange={(e) => setBookData((data) => (
                                        {...data, category: e.target.value}
                                    ))}
                                >
                                    <option value={null} selected disabled>
                                        ---Choose subject area---
                                    </option>
                                    {categories.map((category, i) => (
                                        <option value={category} >{category}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="file-btn-container">
                                <input 
                                    type="file"
                                    className="file-button"
                                    ref={fileButton}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        let fileType = e.target.files[0].type;
                                        if (fileType !== "application/pdf") {
                                            setOnErr(true);
                                            setValError({
                                                caption: "Error",
                                                message: "Invalid file type. Only pdf files are allowed"
                                            })
                                            return;
                                        }
                                        setBookData((data) => (
                                            {
                                                ...data, 
                                                document: e.target.files[0],
                                                fileUrl: publication.document
                                            }
                                        ))
                                    }} 
                                />
                                <button
                                    onClick={() => fileButton.current.click()}
                                    className="file-click"
                                >
                                    <FontAwesomeIcon icon={faFileUpload} style={{marginRight: 8}} />
                                    Select notes file
                                </button>
                                {bookData?.document && (
                                    <div className="file-name">
                                        <FontAwesomeIcon icon={faFilePdf} color="#f00" />
                                        {"  "}
                                        {bookData?.document.name}
                                    </div>
                                )}
                            </div>
                            
                            <button 
                                className="form-button"
                                onClick={ async (e) => {
                                    e.preventDefault();
                                    if (inputRequired()) {
                                        setOnErr(true);
                                        setValError((err) => (
                                            {
                                                ...err, 
                                                caption: "Error!",
                                                message: "Please provide all the required data"
                                            }
                                        ))
                                        return;
                                    }else{
                                        setOnErr(false);
                                        setValError((err) => ({...err, caption: null, message: null}));
                                    }
                                    handleUpload(id, token, {...bookData });
                                   
                                }}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
                <AppFooter />
            </div>
        
    )
}